export default "__VITE_ASSET__DvoTg7cF__"